import React from 'react';
import './ToddlerSessions.css';
import '../common/form-buttons/FormTemplate.css'
import {setPageContentMargin, randomString} from "../../../Utils";
import DataGrid from "../common/data-grid/DataGrid";
import ToddlerSessions from "./ToddlerSessions";
import PageHeader from "../common/page-header/PageHeader";
import Button from "react-bootstrap/Button";
import Notification from "../common/notification/Notification";
import {formatDate} from "../../../Utils";

class ToddlerSessionsPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			// url: "http://localhost/rfk-rest/rfk-api/api/toddler-sessions",
			url: "https://api.repeatforkids.co.uk/api/toddler-sessions",
			page: 'home',
			loading: true,
			table_data: [],
			session_data: [],
			selected_session: "",
			success: ""
		};
	}

	componentDidMount() {
		setPageContentMargin();
		this.getSessions();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		setPageContentMargin();
		if (prevState.selected_session !== this.state.selected_session) {
			if (this.state.selected_session !== "" && this.state.selected_session !==0) {
				this.getSessionDetails(this.state.selected_session);
			} else {
				this.getSessions();
			}
		}
	}

	getSessions = () => {
		let formData = new FormData();
		formData.append('action', 'get-toddler-sessions');
		formData.append('table_view', 1);
		formData.append('recent', (this.props.recent) ? 1 : 0)

		fetch(this.state.url, {
			method: 'POST',
			headers: new Headers(),
			body: formData
		}).then( (response) => {
			if (response.status === 200) {
				return response.json();
			} else {
				throw Error();
			}
		}).then( (data) => {
			this.prepareDataForTable(data.data)
		}).catch( (e) => {
			this.setState({
				error: "Something went wrong. Please try again later."
			});
		});
	}

	getSessionDetails = (session_id) => {
		let formData = new FormData();
		formData.append('action', 'get-toddler-session-details');
		formData.append('session_id', session_id)

		fetch(this.state.url, {
			method: 'POST',
			headers: new Headers(),
			body: formData
		}).then( (response) => {
			if (response.status === 200) {
				return response.json();
			} else {
				throw Error();
			}
		}).then( (data) => {
			this.setState({
				page: "private-hire-form",
				table_data: [],
				session_data: data.data,
				success: ""
			})
		}).catch( () => {
			this.setState({
				error: "Something went wrong. Please try again later."
			});
		});
	}

	prepareDataForTable = (sessions_data) => {
		let columns = [
			{ name: "Name", selector: row => row.name, sortable: true, isDate: false },
			{ name: "Date", selector: row => row.date, sortable: true, isDate: true },
			{ name: "Time", selector: row => row.time, sortable: true, isDate: false },
			{ name: "Booked", selector: row => row.booked, sortable: false, isDate: true },
			{ name: "Reserved", selector: row => row.reserved, sortable: false, isDate: false },
			{ name: "Max", selector: row => row.max, sortable: false, isDate: false },
		];


		let data = [];
		for (let session_data in sessions_data) {
			data.push({
				id: sessions_data[session_data].session_id,
				name: sessions_data[session_data].session_name,
				date: formatDate(sessions_data[session_data].session_date),
				time: sessions_data[session_data].session_time,
				reserved: sessions_data[session_data].session_reserved,
				booked: sessions_data[session_data].session_booked,
				max: sessions_data[session_data].session_max
			});
		}


		this.setState({
			table_data: [columns, data],
			loading: false
		});

	}

	handleNewSession = () => {
		this.setState({
			page: 'new-private-hire',
			selected_session: 0,
			success: ""
		})
	}

	handleRowClick = (row) => {
			this.setState({
				selected_session: row.id,
				success: ""
			});
	}

	handleBackClick = () => {
		this.resetPage()
	}

	handleNewSessionSave = (session_id) => {
		this.setState({
			page: 'private-hire-form',
			selected_session: session_id,
			message: "Private Hire saved!"
		})
	}

	handleSaveExit = () => {
		this.setNotification()
		this.resetPage();
	}

	handleDeletedSession = () => {
		this.setNotification()
		this.resetPage();
	}

	handleDeleteAll = () => {
		if (localStorage.getItem('aawt')) {
			let code = randomString(4)
			let input = window.prompt("Enter the confirmation code: " + code);

			if (code === input) {
					let formData = new FormData();
					formData.append('action', 'delete-all');
					formData.append('token', localStorage.getItem('aawt'))

					fetch(this.state.url, {
						method: 'POST',
						headers: new Headers(),
						body: formData
					}).then((response) => {
						if (response.status === 200) {
							return response.json();
						} else {
							throw Error();
						}
					}).then((data) => {
						if (data.statusCode === 200) {
							this.getSessions();
						} else {
							//todo handle this error
							throw Error()
						}
					}).catch((err) => {
						console.log(err)
						this.setState({
							error: "Something went wrong. Please try again later."
						});
					});

			}
		} else {
			// alert("handle no auth error");
		}
	}

	resetPage = () => {
		this.setState({
			page: "home",
			selected_session: "",
		})
	}

	setNotification = () => {
		this.setState({
			success: true
		})
	}

	render() {

		let notification;
		if (!this.props.recent) {
			if (this.state.success) {
				notification = <Notification type="success" text="Private hire saved" fade={true} form_notification={false}/>
			} else if (!this.state.success && this.state.success !== "") {
				notification = <Notification type="error" text="Saved failed" fade={true} form_notification={false}/>
			}
		}

		let page_title;
		let page_content;
		let show_back;
		let sub_heading = false
		let styling = "page-container";
		if (this.state.page === "home") {
			sub_heading = (this.props.recent) ? true : sub_heading;
			page_title = (this.props.recent) ? 'Recent Private Hire Activity' : 'Private Hire';
			styling = (this.props.recent) ? 'recent-page-content' : styling;
			let add_button = (this.props.recent) ? "" : <Button className="new-session-button" variant="primary" onClick={this.handleNewSession}>Add New Private Hie</Button>;
			let del_all_button = (this.props.recent) ? "" : <Button className="del-all-btn" variant="primary" onClick={this.handleDeleteAll}>Delete All Private Hire</Button>;
			page_content = (<div><DataGrid
					columns={this.state.table_data[0]}
					data={this.state.table_data[1]}
					loading={this.state.loading}
					handleRowClick={this.handleRowClick}
			/>{add_button}{del_all_button}</div>);
			show_back = false;
		} else if (this.state.page === "private-hire-form" && this.state.selected_session !== "")  {
			styling = (this.props.recent) ? 'recent-page-content' : styling;
			page_title = "Edit Private Hire"
			page_content = <ToddlerSessions action="edit" recent={this.props.recent} session={this.state.session_data} handleSaveNotification={this.setNotification} handleSaveExit={this.handleSaveExit} handleDeletedSession={this.handleDeletedSession}/>
			show_back = true;
		} else if (this.state.page === "new-private-hire" && this.state.selected_session !== "") {
			page_title = "New Private Hire";
			page_content = <ToddlerSessions action="create" handleSaveNotification={this.setNotification} handleNewSessionSave={this.handleNewSessionSave} handleSaveExit={this.handleSaveExit} />
			show_back = true;
		}

		return(
			<div className={styling}>
				{notification}
				<PageHeader
					sub_heading={sub_heading}
					page_title={page_title}
					show_back={show_back}
					handleBackClick={this.handleBackClick}
				/>
				<div className="page-content">
					{page_content}
				</div>
			</div>
        );
	}

}

export default ToddlerSessionsPage;